import axiosApp from "../utils/axiosConfig";
// const axiosConfig = {
//     headers: {
//       "content-Type": "application/json",
//       Accept: "/",
//       "Cache-Control": "no-cache",
//       // Cookie: document.cookie,
//     },
//     // credentials: "same-origin",
// };

const listUrl = `${process.env.REACT_APP_API_IP}/api/v1/lists`;

export const getAllLists = async (token) => {
  return await axiosApp.get(listUrl, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const getSingleList = async (token, listId) => {
  return await axiosApp.get(listUrl + "/" + listId, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const createList = async (token, newList) => {
  const res = await axiosApp.post(listUrl, newList, {
    headers: { Authorization: "Bearer " + token },
  });
  return res.data.data;
};

export const updateList = async (token, listId, newList) => {
  try {
    await axiosApp.patch(listUrl + "/" + listId, newList, {
      headers: { Authorization: "Bearer " + token },
    });
    return null;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteList = async (token, listId) => {
  const response = await axiosApp.delete(listUrl + "/" + listId, {
    headers: { Authorization: "Bearer " + token },
  });
  if (response.status === 204) {
    return true;
  } else {
    return false;
  }
};
